import LOCALS from 'commons/locals';
import { CreateProductFormSchemaType } from '../common';
import { Control, Controller } from 'react-hook-form';
import { FormLabel } from '../form-label';
import i18n from 'i18n';
import { Select } from 'antd';
import { selectGlobalInfo } from 'store/slices/globalInfoSlice';
import { useAppSelector } from 'store/hooks';

const ProductColors = ({
  control,
}: {
  control: Control<CreateProductFormSchemaType>;
}) => {
  const { hueSelectOptions } = useAppSelector(selectGlobalInfo);

  return (
    <div className="flex items-center gap-2">
      <FormLabel>{i18n.t(LOCALS.hue)}:</FormLabel>
      <Controller
        name="colors"
        control={control}
        render={({ field }) => (
          <Select
            {...field}
            options={hueSelectOptions}
            className="w-full"
            placeholder={i18n.t(LOCALS.please_select) || ''}
            allowClear
          />
        )}
      />
    </div>
  );
};

export default ProductColors;
